export const CHARTER_FLIGHT_DESCRIPTION_BOTTOM_SHEET =
  'charter-flight-description-bottom-sheet';
